import { render, staticRenderFns } from "./CallMatch.vue?vue&type=template&id=4824d868&"
import script from "./CallMatch.vue?vue&type=script&lang=js&"
export * from "./CallMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports